import React, { useState, useEffect } from "react";
import api from '../api/api';
import { useTranslation } from "react-i18next";
import ChatComponent from "./ChatComponent";

const MatchRequestCard = ({ request, user, onRespond, onRecenterMap, event, refreshMatchRequests }) => {
    const [receiver, setReceiver] = useState(null);
    const [sender, setSender] = useState(null);
    const [eventTitle, setEventTitle] = useState("");
    const [isReceiver, setIsReceiver] = useState(false);
    const [isSender, setIsSender] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);
    const [message, setMessage] = useState("");
    const [loadingEmail, setLoadingEmail] = useState(false);
    const [sentSuccess, setSentSuccess] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const { t } = useTranslation();

	const handleMessageSent = (message) => {
		// Logique pour envoyer un email
		console.log("Email envoyé avec le message :", message);
	};
		
    useEffect(() => {
		
        const fetchReceiver = async () => {
            try {
                const response = await api.get(`/api/participants/${request.receiver_id}`);
                setReceiver(response.data);
            } catch (error) {
                console.error("❌ Erreur lors de la récupération du receiver :", error);
            }
        };

        const fetchSender = async () => {
            try {
                const response = await api.get(`/api/participants/${request.sender_id}`);
                setSender(response.data);
            } catch (error) {
                console.error("❌ Erreur lors de la récupération du sender :", error);
            }
        };

        const fetchEvent = async () => {
            try {
                const response = await api.get(`/api/events/${request.event_id}`);
                setEventTitle(response.data.title);
            } catch (error) {
                console.error("❌ Erreur lors de la récupération de l'événement :", error);
            }
        };

        fetchReceiver();
        fetchSender();
        fetchEvent();
    }, [request.receiver_id, request.sender_id, request.event_id]);

    useEffect(() => {
        if (receiver && user && receiver.email === user.email) {
            setIsReceiver(true);
        } else {
            setIsReceiver(false);
        }

        if (sender && user && sender.email === user.email) {
            setIsSender(true);
        } else {
            setIsSender(false);
        }
    }, [receiver, sender, user]);


	  
    const handleCardClick = () => {
        if (isReceiver && sender) {
            onRecenterMap(sender.latitude, sender.longitude);
        } else if (isSender && receiver) {
            onRecenterMap(receiver.latitude, receiver.longitude);
        }
    };

    const handleCancelRequest = () => {
        setShowCancelModal(true);
    };

    const confirmCancelRequest = async () => {
        try {
            await api.delete(`/api/match-requests/${request.id}`, {
			  data: {
				my_participant_id: isSender ? sender.id : receiver.id,
			  },
			});
            await api.post("/api/participants/send_match_cancel_email", { 
                receiver_email: receiver.email,
                sender_name: sender.name,
                event_title: eventTitle
            });
            setShowCancelModal(false);
            refreshMatchRequests();
        } catch (error) {
            console.error("❌ Erreur lors de l'annulation de la demande :", error);
            alert("Erreur lors de l'annulation de la demande.");
        }
    };

    const handleRejectRequest = () => {
        setShowRejectModal(true);
    };

    const confirmRejectRequest = async () => {
        try {
            await api.delete(`/api/match-requests/${request.id}`);
            await api.post("/api/participants/send_rejection_email", {
                to_email: sender.email,
                sender_name: sender.name,
                receiver_name: receiver.name,
                event_title: eventTitle
            });

            refreshMatchRequests();
            setShowRejectModal(false);
        } catch (error) {
            console.error("❌ Erreur lors du refus de la demande :", error);
            alert("Une erreur est survenue lors du refus de la demande.");
        }
    };
	


    return (
        <div className="p-4 border rounded-lg shadow-md bg-white flex justify-between items-center cursor-pointer" onClick={handleCardClick}>
            <div>
                {isReceiver ? <p className="text-gray-800 font-semibold">{sender ? `${sender.name}` : t("landing.loading")}</p>
                : isSender ? <p className="text-gray-800 font-semibold">{receiver ? `${receiver.name}` : t("landing.loading")}</p>
                : null}
            </div>
            <div className="flex space-x-2">
                <button className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 ml-4" onClick={handleCancelRequest}>{t("dashboard.reject")}</button>
                <button className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 ml-2" onClick={() => { setLoadingEmail(false); setSentSuccess(false); setShowContactModal(true); }}>{t("dashboard.contact")}</button>
            </div>

			{showContactModal && (
				<div className="modal">
					<ChatComponent
						matchRequestId={request.id}
						participantId={isSender ? sender.id : receiver.id} 
						onMessageSent={handleMessageSent}
						onClose={() => setShowContactModal(false)}
					/>
				</div>
			)}
            {showCancelModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg shadow-lg p-6 w-96">
                        <h2 className="text-xl font-bold text-gray-800 mb-4">Confirmation d'annulation</h2>
                        <p className="text-gray-600 mb-6">{t("dashboard.confirm_cancel_request")}</p>
                        <div className="flex justify-end space-x-4">
                            <button onClick={() => setShowCancelModal(false)} className="px-4 py-2 text-gray-600 border border-gray-400 rounded-md hover:bg-gray-100 transition-all">{t("dashboard.cancel")}</button>
                            <button onClick={confirmCancelRequest} className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-all">{t("dashboard.confirm")}</button>
                        </div>
                    </div>
                </div>
            )}
            {showRejectModal && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg shadow-lg p-6 w-96 animate-fadeIn">
                        <h2 className="text-xl font-bold text-gray-800 mb-4">{t("dashboard.confirmation")}</h2>
                        <p className="text-gray-600 mb-6">{t("dashboard.confirm_reject_request", { sender: sender?.name, event: eventTitle })}</p>
                        <div className="flex justify-end space-x-4">
                            <button onClick={() => setShowRejectModal(false)} className="px-4 py-2 text-gray-600 border border-gray-400 rounded-md hover:bg-gray-100 transition-all">{t("dashboard.cancel")}</button>
                            <button onClick={confirmRejectRequest} className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-all">{t("dashboard.confirm")}</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MatchRequestCard;
